<template>
  <v-container fluid class="subscriptions">
    <CategoryTitle :category="category" :add-container="false" />
    <v-list
      id="subscriptionList"
      flat
      subheader
      dense
      class="cart-item-list checkout-item-list mb-8"
    >
      <v-list-item-group class="flex align-center" :key="renderKey">
        <v-list-item
          v-for="item in activeSubscriptions"
          :key="item.subscriptionPlanId"
          class="pa-0 mb-3"
        >
          <div class="cart-item subscription w-100">
            <v-row no-gutters>
              <v-col
                cols="12"
                sm="2"
                md="2"
                class="d-flex flex-md-row flex-sm-row flex-column align-center pa-2"
              >
                <img
                  v-if="item.product && item.product.mediaURL"
                  :src="item.product.mediaURL"
                  :alt="'Immagine prodotto'"
                />
              </v-col>
              <v-col
                cols="12"
                sm="5"
                md="5"
                lg="6"
                class="d-flex flex-md-row flex-sm-row flex-column align-center pa-2"
              >
                <div
                  class="description px-2 pt-3 px-sm-0 px-md-0 pt-sm-0 pt-md-0"
                >
                  <div class="subscription-title text-wrap">
                    {{ $t("subscriptionsModule.subscription") }}
                  </div>
                  <div class="subscription-name text-wrap">
                    {{ item.name }}
                  </div>
                  <div class="subscription-description text-wrap">
                    {{ item.descr }}
                  </div>
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="5"
                md="5"
                lg="4"
                class="d-flex flex-column grey lighten-1 justify-center align-center text-center pa-2"
              >
                <div class="d-flex flex-column gap-2" v-if="isExpired(item)">
                  <div
                    class="d-flex justify-center subscription-status expired"
                  >
                    {{ $t("subscriptionsModule.expiredSubscription") }}
                  </div>
                  <div class="d-flex justify-center subscription-expire">
                    <b
                      >{{ $t("subscriptionsModule.expired") }}
                      {{ $dayjs(item.renewalDate).format("D MMMM YYYY") }}</b
                    >
                  </div>
                  <v-btn
                    large
                    depressed
                    class="primary subs-btn expired-btn"
                    @click.stop.prevent="addSubscriptionPlan(item)"
                    :disabled="
                      subscriptionAdded(item.subscriptionPlanId) ||
                        !cart.homeDelivery
                    "
                  >
                    <span>
                      {{ $t("subscriptionsModule.renewSubscription") }}
                    </span>
                  </v-btn>
                </div>
                <div
                  class="d-flex flex-column gap-2"
                  v-else-if="!isExpiring(item) && !isExpired(item)"
                >
                  <div class="d-flex justify-center subscription-status">
                    {{ $t("subscriptionsModule.activeSusbscription") }}
                  </div>
                  <div class="d-flex justify-center subscription-expire">
                    Scadenza
                    {{ $dayjs(item.renewalDate).format("D MMMM YYYY") }}
                  </div>
                  <v-btn
                    large
                    depressed
                    class="primary subs-btn"
                    @click.stop.prevent="addSubscriptionPlan(item)"
                    :disabled="
                      isAuthenticated &&
                        (subscriptionAdded(item.subscriptionPlanId) ||
                          subscriptionAdded(item.subscriptionPlanId) ||
                          !isExpiring(item))
                    "
                  >
                    <span>
                      {{ $t("subscriptionsModule.renewSubscription") }}
                    </span>
                  </v-btn>
                  <div class="d-flex justify-center subscription-renew-date">
                    {{
                      $t("subscriptionsModule.renewDate", {
                        date: $dayjs(item.renewalDate).format("D MMMM YYYY")
                      })
                    }}
                  </div>
                </div>
                <div
                  class="d-flex flex-column gap-2"
                  v-else-if="isExpiring(item)"
                >
                  <div
                    class="d-flex justify-center subscription-status expiring"
                  >
                    {{ $t("subscriptionsModule.expiringSubscription") }}
                  </div>
                  <div class="d-flex justify-center subscription-expire">
                    {{ $t("subscriptionsModule.expiring") }}
                    {{ $dayjs(item.renewalDate).format("D MMMM YYYY") }}
                  </div>
                  <v-btn
                    large
                    depressed
                    class="primary subs-btn expired-btn"
                    @click.stop.prevent="addSubscriptionPlan(item)"
                    :disabled="
                      subscriptionAdded(item.subscriptionPlanId) ||
                        !cart.homeDelivery
                    "
                  >
                    <span>
                      {{ $t("subscriptionsModule.renewSubscription") }}
                    </span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <h3 class="text-center">{{ $t("subscriptionsModule.desc") }}</h3>
    <v-row class="pa-4 mb-4" no-gutters>
      <v-col
        cols="12"
        sm="3"
        md="3"
        class="d-flex flex-column text-center justify-center align-center gap-1 h-100 px-2 pb-0 pt-4"
        v-for="(step, index) in Object.keys($t('subscriptions')).length"
        :key="index"
      >
        <div
          class="primary white--text default--text dot d-flex justify-center align-center"
        >
          <span
            class="number"
            v-html="$t('subscriptions.' + Number(index + 1) + '.number')"
          ></span>
        </div>
        <div class="stepper-title">
          <strong
            v-html="$t('subscriptions.' + Number(index + 1) + '.title')"
          ></strong>
        </div>
        <div>
          <p
            class="stepper-description"
            v-html="$t('subscriptions.' + Number(index + 1) + '.description')"
          ></p>
        </div>
      </v-col>
    </v-row>

    <v-list
      id="subscriptionList"
      flat
      subheader
      dense
      class="cart-item-list checkout-item-list"
    >
      <v-list-item-group class="flex align-center" :key="renderKey">
        <v-list-item
          v-for="item in notActiveSubscriptions"
          :key="item.subscriptionPlanId"
          class="pa-0 mb-6"
        >
          <div class="cart-item subscription w-100">
            <v-row no-gutters>
              <v-col
                cols="12"
                sm="2"
                md="2"
                class="d-flex flex-md-row flex-sm-row flex-column align-center pa-2"
              >
                <img
                  v-if="item.product && item.product.mediaURL"
                  :src="item.product.mediaURL"
                  :alt="'Immagine prodotto'"
                />
              </v-col>
              <v-col
                cols="12"
                sm="5"
                md="5"
                lg="6"
                class="d-flex flex-md-row flex-sm-row flex-column align-center pa-2"
              >
                <div
                  class="description px-2 pt-3 px-sm-0 px-md-0 pt-sm-0 pt-md-0"
                >
                  <div class="subscription-title text-wrap">
                    {{ $t("subscriptionsModule.subscription") }}
                  </div>
                  <div class="subscription-name text-wrap">
                    {{ item.name }}
                  </div>
                  <div class="subscription-description text-wrap">
                    {{ item.descr }}
                  </div>
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="5"
                md="5"
                lg="4"
                class="d-flex flex-column grey lighten-1 justify-center align-center text-center pa-2"
              >
                <div
                  v-if="subscriptionOrdered(item)"
                  class="d-flex justify-center subscription-status"
                >
                  <p>
                    {{ $t("subscriptionsModule.orderedSubscription") }}
                  </p>
                </div>
                <div
                  class="d-flex flex-column subscription-price"
                  v-if="
                    !isAuthenticated ||
                      (isAuthenticated &&
                        $vuetify.breakpoint.smAndUp &&
                        !subscriptionActive(item) &&
                        item.product)
                  "
                >
                  <ProductPrice
                    v-if="item.product.priceDisplay"
                    :product="item.product"
                    :showDescrWeight="false"
                    :showOldPrice="false"
                  ></ProductPrice>
                  <div class="my-1" v-else>
                    {{ $t("subscriptionsModule.notAvailable") }}
                  </div>
                </div>
                <v-btn
                  large
                  depressed
                  class="primary subs-btn"
                  @click.stop.prevent="addSubscriptionPlan(item)"
                  :disabled="
                    (isAuthenticated &&
                      (subscriptionAdded(item.subscriptionPlanId) ||
                        !subscriptionPaid(item))) ||
                      !item.product.priceDisplay
                  "
                >
                  <v-icon color="white" class="mr-2">$cart</v-icon>
                  <span>
                    {{ $t("subscriptionsModule.addToCart") }}
                  </span>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-container>
</template>
<script>
import catalogService from "@/commons/service/catalogService";
import subscriptionPlanService from "@/commons/service/subscriptionPlanService";
import userService from "@/commons/service/userService";
import CategoryTitle from "@/components/category/CategoryTitle.vue";
import ProductPrice from "@/components/product/ProductPrice.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import categoryMixins from "~/mixins/category";

export default {
  name: "Subscriptions",
  mixins: [categoryMixins],
  components: {
    CategoryTitle,
    ProductPrice
  },
  data() {
    return {
      renderKey: 1,
      subscriptions: [],
      userSubscriptions: []
    };
  },
  computed: {
    ...mapState({
      cart: ({ cart }) => cart.cart
    }),
    ...mapGetters({
      getCartStatus: "cart/getCartStatus",
      isAuthenticated: "cart/isAuthenticated"
    }),
    activeSubscriptions() {
      return this.subscriptions.filter(sub => this.subscriptionActive(sub));
    },
    notActiveSubscriptions() {
      return this.subscriptions.filter(sub => !this.subscriptionActive(sub));
    }
  },
  methods: {
    ...mapActions({
      lockCart: "cart/lockCart",
      loadCart: "cart/loadCart",
      emptyCart: "cart/emptyCart",
      addGiftCode: "cart/addGiftCode",
      sendGiftCode: "cart/sendGiftCode",
      removeGiftCode: "cart/removeGiftCode"
    }),
    async addUserGiftCode(giftCodeId) {
      let cart = await this.addGiftCode(giftCodeId);
      if (cart) {
        this.getUserDetails();
      }
    },
    async sendUserGiftCode(giftCodeId) {
      let cart = await this.sendGiftCode(giftCodeId);
      if (cart) {
        this.getUserDetails();
      }
    },
    async removeUserGiftCode(giftCodeId) {
      let cart = await this.removeGiftCode(giftCodeId);
      if (cart) {
        this.getUserDetails();
      }
    },
    async getUserDetails() {
      const data = await userService.getUserDetail();
      this.giftCertificatesReceived = data ? data.giftCertificatesReceived : [];
    },
    async getSubscriptionsList() {
      let subscriptions = await subscriptionPlanService.subscriptionPlanList();
      this.subscriptions = subscriptions.subscriptionPlans;
    },
    async getUserSubscriptionsList() {
      let userSubscriptions = await subscriptionPlanService.userSubscriptionPlanList();
      this.userSubscriptions = userSubscriptions.subscriptionPlans
        ? userSubscriptions.subscriptionPlans
        : [];
    },
    async addSubscriptionPlan(subscriptionPlan) {
      let result = await subscriptionPlanService.addSubscriptionPlan(
        subscriptionPlan
      );
      if (
        (result.response && result.response.status == 0) ||
        result.status == 0
      ) {
        this.loadCart();
        this.subscriptions = result.data.subscriptionPlans;
      }
    },
    pricePerUnit(product) {
      return (
        product.price *
        parseFloat(
          Number(product.productInfos.WEIGHT_SELLING) /
            catalogService.getMultiplier(product)
        )
      );
    },
    subscriptionOrdered(subscription) {
      let isActive = false;
      let userSubscription = null;
      this.userSubscriptions.filter(ub => {
        if (ub.subscriptionPlanUsers) {
          return ub.subscriptionPlanUsers.filter(ss => {
            if (ub.subscriptionPlanId == subscription.subscriptionPlanId) {
              userSubscription = ss;
            }
          });
        }
      });
      if (
        userSubscription &&
        userSubscription.active == 1 &&
        userSubscription.subscriptionPlanUserStatus &&
        userSubscription.subscriptionPlanUserStatus
          .subscriptionPlanUserStatusId == 3 &&
        subscription.active == 1
      ) {
        isActive = true;
      }
      return isActive;
    },
    subscriptionActive(subscription) {
      let isActive = false;
      let userSubscription = null;
      this.userSubscriptions.filter(ub => {
        if (ub.subscriptionPlanUsers) {
          return ub.subscriptionPlanUsers.filter(ss => {
            if (ub.subscriptionPlanId == subscription.subscriptionPlanId) {
              userSubscription = ss;
            }
          });
        }
      });
      if (
        userSubscription &&
        userSubscription.active == 1 &&
        userSubscription.subscriptionPlanUserStatus &&
        userSubscription.subscriptionPlanUserStatus
          .subscriptionPlanUserStatusId == 8 &&
        subscription.active == 1
      ) {
        isActive = true;
      }
      return isActive;
    },
    subscriptionAdded(subscriptionPlanId) {
      let result = false;
      for (var i = 0; this.cart.cartItems.length > i; i++) {
        if (
          this.cart.cartItems[i].cartItemInfo.SUBSCRIPTION_PLAN_ID ==
          subscriptionPlanId
        ) {
          result = true;
          break;
        }
      }
      return result;
    },
    subscriptionPaid(subscription) {
      let subscriptionPaid = true;
      let userSubscription = null;
      this.userSubscriptions.filter(ub => {
        if (ub.subscriptionPlanUsers) {
          return ub.subscriptionPlanUsers.filter(ss => {
            if (ub.subscriptionPlanId == subscription.subscriptionPlanId) {
              userSubscription = ss;
            }
          });
        }
      });
      if (
        userSubscription &&
        userSubscription.active == 1 &&
        userSubscription.subscriptionPlanUserStatus &&
        userSubscription.subscriptionPlanUserStatus
          .subscriptionPlanUserStatusId == 3 &&
        subscription.active == 1
      ) {
        subscriptionPaid = false;
      }
      return subscriptionPaid;
    },
    isExpired(subscription) {
      let userSubscription = null;
      this.userSubscriptions
        .filter(ub => ub.subscriptionPlanUsers)
        .forEach(ub => {
          ub.subscriptionPlanUsers.forEach(ss => {
            if (ub.subscriptionPlanId == subscription.subscriptionPlanId) {
              userSubscription = ss;
            }
          });
        });
      let result = false;
      if (userSubscription.active === 1) {
        subscription.renewalDate = this.$dayjs(userSubscription.endDate).format(
          "YYYY-MM-DD"
        );
      }
      if (
        !userSubscription.active ||
        (userSubscription.active && userSubscription.active === 0) ||
        (userSubscription.active &&
          userSubscription.active === 1 &&
          this.$dayjs(userSubscription.endDate).format("YYYY-MM-DD") <
            this.$dayjs().format("YYYY-MM-DD"))
      ) {
        result = true;
      }
      return result;
    },
    isExpiring(subscription) {
      let userSubscription = null;
      this.userSubscriptions
        .filter(ub => ub.subscriptionPlanUsers)
        .forEach(ub => {
          ub.subscriptionPlanUsers.forEach(ss => {
            if (ub.subscriptionPlanId == subscription.subscriptionPlanId) {
              userSubscription = ss;
            }
          });
        });
      let result = false;
      if (userSubscription.active === 1) {
        subscription.renewalDate = this.$dayjs(userSubscription.endDate);
      }
      if (
        userSubscription.active === 1 &&
        this.$dayjs(userSubscription.endDate) &&
        subscription.renewalDaysBefore >=
          this.$dayjs(userSubscription.endDate).diff(
            this.$dayjs().format("YYYY-MM-DD"),
            "day"
          )
      ) {
        result = true;
      }
      return result;
    },
    async reload() {
      await this.getSubscriptionsList();
      await this.getUserSubscriptionsList();
    }
  },
  async mounted() {
    await this.reload();
  }
};
</script>
<style lang="scss">
.subscriptions {
  .dot {
    height: 50px;
    width: 50px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    .number {
      position: absolute;
      font-size: 20px;
      font-weight: 700;
    }
  }
  .stepper-title {
    font-size: 20px;
  }
  .stepper-description {
    font-size: 14px;
  }
  .subscription {
    border: 2px solid var(--v-grey-base) !important;
    border-radius: 6px;
    img {
      max-width: 100%;
      width: auto;
      height: auto;
    }
    .description {
      .subscription-title,
      .subscription-name {
        font-size: 20px;
      }
      .subscription-name {
        font-weight: 600;
      }
      .subscription-description {
        font-size: 14px;
      }
    }
  }
  .subscription-price {
    .cur-price {
      font-size: 24px !important;
      font-weight: 900;
      margin-bottom: 6px;
    }
  }
  .subscription-status {
    color: var(--v-primary-base);
    font-size: 20px;
    font-weight: 900;
  }
  .subscription-expire {
    font-weight: 600;
    font-size: 14px;
  }
  .subscription-renew-date {
    font-size: 12px;
  }
}
</style>
